"use client";
import Script from "next/script";
import identifyUser from "../utils/identifyUser";

type Props = {
  src?: string;
  liveChatSettings: LiveChatSettings;
  profileId?: string;
  isLoggedIn: boolean;
};
const ChatClientScript: FC<Props> = ({
  src,
  liveChatSettings,
  profileId,
  isLoggedIn,
}) => {
  const chatSettings = {
    ...liveChatSettings,
    onInit: async () => {
      identifyUser(isLoggedIn, profileId);
    },
  };
  const handleOnLoad = () => {
    window.proto?.init(chatSettings);
  };

  return (
    <Script
      src={src}
      async
      type="text/javascript"
      strategy="lazyOnload"
      onLoad={handleOnLoad}
      key={profileId || ""}
    />
  );
};

export default ChatClientScript;
